<!--
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
-->

<div class="windows-col" id='window-pref-{{tabLevel}}'>
    <p-dropdown [panelStyleClass]="'dialog-dropdown'" [options]="windowNameList" [tabindex]='tabLevel' (onChange)='changeWindowName()' [(ngModel)]='selectedWindowName'>
        <ng-template let-windowName pTemplate="item">
            <div>
                <div>{{windowName.label}}</div>
                <span *ngIf="'Terminal Notes'===windowName.label||
        'Locomotive Notes'===windowName.label ||
         'Train Notes'===windowName.label" class="break-line"></span>
            </div>
        </ng-template>
    </p-dropdown>
    <div>
        <a href="javascript:void(0)" class="clear-link" *ngIf="selectedWindowName" (keydown.space)='clearWindow();' (keydown.spacebar)='clearWindow();'
            tabindex="{{tabLevel+3}}" (click)="clearWindow()">Clear</a>
        <span *ngIf="!selectedWindowName">&nbsp;</span>
    </div>
</div>

<div class="mnemonic-col">
    <lms-autocomplete [inputId]='"userProfileTerminalMnemonic"+index' [tabindex]='tabLevel+1' *ngIf="selectedWindowName === 'Terminal Status' || selectedWindowName === 'Terminal Handling'"
        styleclass="p-autocomplete" [(ngModel)]="userPrefWindow.terminalMnemonic" spellcheck="false" [ngClass]="'terminal-autocomplete'"
        placeholder="Mnemonic" [suggestions]="filteredResults" (completeMethod)="autoCompleteForTerminal($event)" [minLength]="2"
        (onSelect)="selectValueFromAutoComplete(userPrefWindow.terminalMnemonic)" inputStyleClass="{{userPrefWindow && userPrefWindow.isMnemonicError ? 'p-inputfield-error' : ''}}"
        [maxlength]="6"></lms-autocomplete>
    <div class="color-red clearfix" *ngIf='userPrefWindow && userPrefWindow.isMnemonicError'> Please Enter a valid mnemonic </div>

    <p-dropdown [panelStyleClass]="'dialog-dropdown'" [inputId]='"userProfileOutlyingDesk"+index' [tabindex]='tabLevel+1' (onChange)='changeDeskName()' *ngIf="selectedWindowName === 'Outlying-Points Data'"
        [options]="deskList" [(ngModel)]='selectedDeskName'>
        <ng-template let-deskName pTemplate="deskName">
            <div class="p-helper-clearfix">
                <div> {{deskName.label}} </div>
            </div>
        </ng-template>
    </p-dropdown>
</div>

<div class="no-t-trains" *ngIf="selectedWindowName === 'Terminal Status'">
    <p-checkbox [tabindex]='tabLevel+2' [(ngModel)]='noThroughTrains' label="No Through Trains" binary="true" (onChange)='onChange($event);'></p-checkbox>
</div>

<div class="eta-etd-time" *ngIf="selectedWindowName === 'Terminal Status' ||
 selectedWindowName === 'Terminal Handling' || selectedWindowName === 'Outlying-Points Data'">
    <span class="light-grey-text">Default ETA/ETD: 24 Hrs</span>
</div>